(function(){
  'use strict';

  var state={mode:'featured'};
  var HIGHEST=/highest\s*(rating|rated)/i;
  var RECENT=/most\s*recent|newest/i;

  function getSection(){
    return document.querySelector('[id*="dog_harness_reviews"]');
  }

  function findSortSelect(section){
    if(!section) return null;
    var selects=section.querySelectorAll('select');
    for(var i=0;i<selects.length;i++){
      var options=Array.prototype.slice.call(selects[i].options||[]);
      if(options.some(function(option){return HIGHEST.test((option.textContent||'').trim());})) return selects[i];
    }
    return null;
  }

  function findOption(select,matcher){
    if(!select) return null;
    var options=Array.prototype.slice.call(select.options||[]);
    for(var i=0;i<options.length;i++){
      if(matcher.test((options[i].textContent||'').trim())) return options[i];
    }
    return null;
  }

  function selectOption(select,matcher){
    var option=findOption(select,matcher);
    if(!option) return false;
    if(select.value!==option.value){
      select.value=option.value;
      select.dispatchEvent(new Event('input',{bubbles:true}));
      select.dispatchEvent(new Event('change',{bubbles:true}));
    }
    return true;
  }

  function updateToolbar(toolbar){
    if(!toolbar) return;
    var label=toolbar.querySelector('[data-vp-review-mode]');
    var button=toolbar.querySelector('[data-vp-review-toggle]');
    if(state.mode==='featured'){
      if(label) label.textContent='Highest-rated reviews are shown first. All published ratings remain available.';
      if(button) button.textContent='View all reviews';
    }else{
      if(label) label.textContent='All published reviews are shown with the most recent first.';
      if(button) button.textContent='Show highest rated first';
    }
  }

  function createToolbar(section,select){
    var existing=section.querySelector('[data-vp-featured-reviews]');
    if(existing) return existing;

    var highest=findOption(select,HIGHEST);
    var recent=findOption(select,RECENT);
    if(!highest || !recent) return null;

    var toolbar=document.createElement('div');
    toolbar.className='vp-featured-reviews';
    toolbar.setAttribute('data-vp-featured-reviews','');
    toolbar.innerHTML='<div class="vp-featured-reviews__copy"><span class="vp-featured-reviews__eyebrow">Featured reviews</span><p data-vp-review-mode>Highest-rated reviews are shown first. All published ratings remain available.</p></div><button class="vp-featured-reviews__toggle" type="button" data-vp-review-toggle>View all reviews</button>';

    section.insertBefore(toolbar,section.firstChild);

    toolbar.querySelector('[data-vp-review-toggle]').addEventListener('click',function(){
      var currentSelect=findSortSelect(section);
      if(!currentSelect) return;
      if(state.mode==='featured'){
        if(selectOption(currentSelect,RECENT)) state.mode='all';
      }else{
        if(selectOption(currentSelect,HIGHEST)) state.mode='featured';
      }
      updateToolbar(toolbar);
    });

    select.addEventListener('change',function(){
      var selected=(select.options[select.selectedIndex]||{}).textContent||'';
      if(HIGHEST.test(selected)) state.mode='featured';
      else if(RECENT.test(selected)) state.mode='all';
      updateToolbar(toolbar);
    });

    return toolbar;
  }

  function apply(){
    var section=getSection();
    if(!section) return false;
    var select=findSortSelect(section);
    if(!select) return false;

    var toolbar=createToolbar(section,select);
    if(!toolbar) return false;

    if(state.mode==='featured') selectOption(select,HIGHEST);
    else selectOption(select,RECENT);
    updateToolbar(toolbar);
    return true;
  }

  function init(){
    var attempts=0;
    function retry(){
      attempts+=1;
      if(apply() || attempts>=12) return;
      window.setTimeout(retry,350);
    }
    retry();

    var observer=new MutationObserver(function(){
      window.clearTimeout(observer._vpTimer);
      observer._vpTimer=window.setTimeout(apply,120);
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
